import { render, staticRenderFns } from "./mostly-search.vue?vue&type=template&id=2cd24c55&scoped=true"
import script from "./mostly-search.vue?vue&type=script&lang=js"
export * from "./mostly-search.vue?vue&type=script&lang=js"
import style0 from "./mostly-search.vue?vue&type=style&index=0&id=2cd24c55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd24c55",
  null
  
)

export default component.exports